import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

import './index.scss';

import * as searchIcon from './static/img/search.svg';

interface Props {
  isFirst?: boolean;
  isLast?: boolean;
  value?: string;
  onChange: (value?: string) => void;
}

interface State {
  visible: boolean;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('stocks-filter-input');

const enhance = compose<Enhanced, Props>(translate);

class StocksFilterInput extends React.Component<Enhanced, State> {
  readonly state: State = {
    visible: false,
  };

  private input: HTMLInputElement | null = null;

  componentDidMount() {
    const { value } = this.props;
    if (!value || /^\s*$/.test(value)) {
      return;
    }
    this.setState(() => ({ visible: true }));
  }

  render() {
    const { isFirst, isLast } = this.props;

    return (
      <>
        <div className={b({ 'is-first': isFirst, 'is-last': isLast })} onClick={this.open}>
          <div className={b('row')}>
            <img className={b('search-icon')} src={searchIcon} alt="" />
          </div>
        </div>
        {this.renderInput()}
      </>
    );
  }

  private renderInput() {
    if (!this.state.visible) {
      return null;
    }

    const { t, value } = this.props;

    return (
      <div className={b('input')}>
        <input
          ref={(el) => (this.input = el)}
          className={b('input-field')}
          placeholder={t('Search by name')}
          value={value || ''}
          onChange={this.handleInput}
          onKeyDown={this.keyDown}
        />
        <div className={b('close-icon')} onClick={this.close} />
      </div>
    );
  }

  private close = () => {
    this.setState({ visible: false });
    this.props.onChange();
  };

  private open = () => {
    this.setState({ visible: true }, () => this.input && this.input.focus());
  };

  private handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(e.target.value);
  };

  private keyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      this.close();
    }
  };
}

export default enhance(StocksFilterInput);
